import { createSelector } from '@reduxjs/toolkit';

import { AnalyticsQueryTemplate, QueryType } from 'dashboard/models/analytics-query-template';
import { RootState } from 'dashboard/redux/store';

const getAnalyticsQueryTemplates = (state: RootState) => state.analyticsQueryTemplates;

export const getAnalyticsQueryTemplatesSelector = createSelector(
  [getAnalyticsQueryTemplates],
  (analyticsQueryTemplates) => analyticsQueryTemplates.templates,
);

export const getInquiryAnalyticsQueryTemplatesSelector = createSelector(
  [getAnalyticsQueryTemplatesSelector],
  (analyticsQueryTemplates) =>
    analyticsQueryTemplates.filter(
      (template: AnalyticsQueryTemplate) => template.attributes.query.type === QueryType.Inquiries,
    ),
);

export const getVerificationVolumeAnalyticsQueryTemplatesSelector = createSelector(
  [getAnalyticsQueryTemplatesSelector],
  (analyticsQueryTemplates) =>
    analyticsQueryTemplates.filter(
      (template: AnalyticsQueryTemplate) =>
        template.attributes.query.type === QueryType.VerificationsVolume,
    ),
);

export const getVerificationChecksAnalyticsQueryTemplatesSelector = createSelector(
  [getAnalyticsQueryTemplatesSelector],
  (analyticsQueryTemplates) =>
    analyticsQueryTemplates.filter(
      (template: AnalyticsQueryTemplate) =>
        template.attributes.query.type === QueryType.VerificationsChecks,
    ),
);

export const getVerificationAnalyticsQueryTemplatesSelector = createSelector(
  [
    getVerificationVolumeAnalyticsQueryTemplatesSelector,
    getVerificationChecksAnalyticsQueryTemplatesSelector,
  ],
  (verificationVolumeTemplates, verificationChecksTemplates) => [
    ...verificationVolumeTemplates,
    ...verificationChecksTemplates,
  ],
);
